/**
 * Divider Schema
 * Schema-driven settings with conditional visibility
 */
export default {
  id: 'divider',
  version: 1,
  title: 'Разделитель',
  description: 'Визуальный разделитель между секциями',
  icon: 'Minus',
  category: 'layout',

  fields: [
    {
      group: 'Стиль',
      fields: [
        {
          key: 'style',
          type: 'select',
          label: 'Тип',
          mode: 'grid',
          columns: 3,
          options: [
            { value: 'line', label: 'Линия', icon: 'Minus' },
            { value: 'dots', label: 'Точки', icon: 'MoreHorizontal' },
            { value: 'space', label: 'Отступ', icon: 'Square' }
          ]
        },
        {
          key: 'lineWidth',
          type: 'select',
          label: 'Ширина линии',
          mode: 'grid',
          columns: 4,
          visible: (data) => data?.style === 'line',
          options: [
            { value: 'narrow', label: 'Узкая' },
            { value: 'medium', label: 'Средняя' },
            { value: 'wide', label: 'Широкая' },
            { value: 'full', label: 'Полная' }
          ]
        },
        {
          key: 'color',
          type: 'select',
          label: 'Цвет',
          mode: 'grid',
          columns: 3,
          visible: (data) => data?.style !== 'space',
          options: [
            { value: 'border', label: 'Серый' },
            { value: 'primary', label: 'Акцент' },
            { value: 'muted', label: 'Светлый' }
          ]
        }
      ]
    }
  ],

  // Дефолтные стили секции
  'x-styles': {
    paddingTop: 32,
    paddingBottom: 32
  },

  default: {
    style: 'line',
    lineWidth: 'medium',
    color: 'border'
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      return { ...this.default, ...data };
    }
    return data;
  }
};
